import React, { memo, useContext } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL VARIABLES
import { INTERFACE, DASHBOARD } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

// HELPERS
import { ListContext } from 'helpers/getListData';

// REACT ROUTER COMPONENTS
import { Link } from 'react-router-dom';

// BOOTSTRAP COMPONENTS
import { Col, Row } from 'react-bootstrap';

// CORE COMPONENTS
import Sprite from 'core/tools/Sprite';
import Button from 'core/tools/Button';

// PART COMPONENTS
import Main from 'parts/main/Main';
import Title from 'parts/title/Title';

// STYLES
import styles from './dashboardIndex.module.scss';

// MAIN COMPONENT
const DashboardIndex = ({ title, pathname }) => {

  // CONTEXT
  const { result = [], loading } = useContext(ListContext) || {};

  // RENDER
  return (
    <Main>
      <Title title={title} />
      {
        loading ?
          <></>
          :
          result?.length ?
            result
              .map((c, i) => <Item c={c} i={i} pathname={pathname} />)
            :
            <div className='d-flex align-items-center'>
              Please go to
              &nbsp;
              <Button.Link
                label='Reports - Graphs'
                to={makePath(INTERFACE.dashboard, DASHBOARD.reports)}
              />
              &nbsp;
              and click on
              &nbsp;
              <Button
                label='Add to My Favorites'
                icon={{
                  use: 'like',
                  order: 1
                }}
                disabled
                className='w-fit'
                outline
              />
              &nbsp;
              button to add graphs to your favorites.
            </div>
      }
    </Main>
  );
};

const Item = memo(({ c, i, pathname }) => (
  <div key={i} className={styles.container}>
    <h3 className={clsx(styles.header, 'fw-bolder')}>{c?.report_category_name}</h3>
    <Row className={styles.row}>
      {c?.reports?.map((r, i) => (
          <Col key={i} className={styles.col} xs={24} sm={12} md={6}>
            <Link
              className={clsx(styles.card, 'h-100')}
              to={r?.is_custom_report
                ? makePath(INTERFACE.dashboard, pathname, DASHBOARD.custom, r.custom_report_code)
                : makePath(INTERFACE.dashboard, pathname, DASHBOARD.report, r.report_id)
              }
            >
              <h4 className="h5">{r?.report_title}</h4>
              <Sprite
                className={clsx(styles.sprite, 'text-highlight')}
                use="chart"
                size="lg"
              />
            </Link>
          </Col>
        )
      )}
    </Row>
  </div>
))


export default DashboardIndex;
